import { Box, styled, Flex } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const Container = styled(Flex)`
  justify-content: flex-start;
  padding: 16px;
  color: #4a4a4a;
  background: #ebfbee;
  border-radius: 12px;
  flex-direction: column;
  margin: 16px 0;
  ${(props) => props.containerStyles}
`;

export const Description = styled(Box)`
  font-size: ${(props) => (props.isDesktop ? "14px" : "12px")};
  font-style: normal;
  font-weight: 400;
  line-height: ${(props) => (props.isDesktop ? "20px" : "18px")};
  color: #5b5675;
  span {
    color: #36354c;
    font-weight: 600;
  }
`;

export const Heading = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: #040222;
  ${(props) => props.wrapperStyles}
`;
